module.exports = __webpack_public_path__ + "img/walletconnect-icon.e9f0f906.svg";